import React from "react";
import { AwardIcon, ClockIcon, CompassIcon, GemIcon, HourglassIcon, RepeatIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { painPoints } from "../../data/content";
const icons = [ClockIcon, HourglassIcon, CompassIcon, GemIcon, RepeatIcon, AwardIcon];
export function SoundsLikeYou() {
  return <Section tone="white" wide data-id="element-225" data-mp="ip2wma78kix7">
      <SectionHeading kicker="Does any of this sound like you?" data-id="element-226" data-mp="ipvusms4q03q">
        If you answer <em className="text-berry" data-id="element-227" data-mp="nne7mo99ozh0">yes</em> to even one, I created this for you.
      </SectionHeading>

      <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-228" data-mp="smqsj3gkvwgy">
        {painPoints.map((p, i) => {
        const Icon = icons[i];
        return <div key={p.title} className="flex gap-4 rounded-2xl border border-petal bg-cream p-5" data-id="element-229" data-mp="xftotjcqpk0u" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blush text-berry" data-id="element-230" data-mp="3w1mudfp3yw19">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-231" data-mp="y4xqs15w8iei" />
              </span>
              <div data-id="element-232" data-mp="y70cwa3xdrdy">
                <h3 className="text-[17px] font-bold leading-snug text-ink" data-id="element-233" data-mp="t5uim7um9w2b">{p.title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-muted" data-id="element-234" data-mp="t872wrnukiij">{p.text}</p>
              </div>
            </div>;
      })}
      </div>

      <div className="mx-auto mt-10 max-w-2xl space-y-3 text-center text-[17px] leading-relaxed text-muted" data-id="element-235" data-mp="jf9pgzxppjqs">
        <p data-id="element-236" data-mp="fg0sznbaf7rj">And it shouldn't be this difficult.</p>
        <p data-id="element-237" data-mp="afmougct4hys">
          Because the problem isn't that you don't know enough.{" "}
          <strong className="text-ink" data-id="element-238" data-mp="5ga17te436v5">
            The problem is that nobody gave you a simple system for turning what you already know into a professional
            nail class.
          </strong>
        </p>
      </div>

      <CTAButton label="I want the system" data-id="element-239" data-mp="1zut25rj092b2" />
    </Section>;
}